<template>
  <SectionBox :class="{ 'expert-card-wrapper--bordered': expert.marked }">
    <BasicSection appearance="same-paddings">
      <article class="expert-card">
        <div v-if="expert.lastVisited" class="expert-card__last-visited">
          <BasicDate
            :date="expert.lastVisited.date"
            :title="expert.lastVisited.title"
          />
        </div>

        <aside class="expert-card__aside">
          <BasicAvatar
            :href="expertLink"
            :image="expert.avatar"
            size="medium"
            roundness="full"
          />
        </aside>

        <div class="expert-card__main">
          <div class="expert-card__body">
            <div class="expert-card__header">
              <h2 class="expert-card__title">
                <a
                  :href="expertLink"
                  class="expert-card__title-link"
                  target="_blank"
                  v-text="expert.title"
                />
                <InlineIconsList>
                  <ExpertIcon />
                </InlineIconsList>
              </h2>

              <InlineList
                v-if="experience.length"
                :items="experience"
                v-slot="{ item }"
              >
                <span v-text="item" />
              </InlineList>

              <InlineList
                v-if="lastJob.length"
                :items="lastJob"
                v-slot="{ item }"
              >
                <InlineListLink :item="item" />
              </InlineList>
            </div>

            <ExpertStats class="expert-card__stats" :score="expert.score" />

            <ContentSection title="Могу помочь" appearance="expert-profile">
              <SectionGroup gap="medium-large">
                <ExpertRequestsList
                  no-link
                  :requests="qualificationsAndSpecializations"
                />
                <ExpertRequestsList v-if="skills" no-link :requests="skills" />
                <ExpertRequestsList no-link :requests="expert.requests" />
              </SectionGroup>
            </ContentSection>
          </div>
          <div class="expert-card__footer">
            <ExpertCost :rate="expert.rate" />

            <template v-if="!viewedByOwner">
              <ConsultationRequestButton
                :expert-login="expert.alias"
                place="card"
              />
            </template>
          </div>
        </div>
      </article>
    </BasicSection>
  </SectionBox>
</template>

<script>
import BasicAvatar from 'src/components/BasicAvatar/BasicAvatar.vue';
import BasicDate from 'src/components/BasicDate/BasicDate.vue';
import ConsultationRequestButton from 'src/components/ConsultationRequestButton/ConsultationRequestButton.vue';
import ExpertCost from 'src/components/experts/ExpertCost/ExpertCost.vue';
import ExpertIcon from 'src/components/experts/ExpertIcon/ExpertIcon.vue';
import ExpertRequestsList from 'src/components/experts/ExpertRequestsList/ExpertRequestsList.vue';
import ExpertStats from 'src/components/experts/ExpertStats/ExpertStats.vue';
import InlineIconsList from 'src/components/InlineIconsList/InlineIconsList.vue';
import InlineList from 'src/components/InlineList/InlineList.vue';
import InlineListLink from 'src/components/InlineListLink/InlineListLink.vue';
import SectionBox from 'src/components/SectionBox/SectionBox.vue';
import BasicSection from 'src/components/sections/BasicSection/BasicSection.vue';
import ContentSection from 'src/components/sections/ContentSection/ContentSection.vue';
import SectionGroup from 'src/components/sections/SectionGroup/SectionGroup.vue';

export default {
  name: 'ExpertCard',
  components: {
    ConsultationRequestButton,
    InlineIconsList,
    ExpertCost,
    SectionGroup,
    InlineListLink,
    ExpertRequestsList,
    ExpertStats,
    ExpertIcon,
    ContentSection,
    InlineList,
    BasicAvatar,
    BasicDate,
    SectionBox,
    BasicSection,
  },
  inject: ['mediaQueries'],
  props: {
    expert: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
    connections: {
      type: Array,
      required: true,
    },
  },
  computed: {
    viewedByOwner() {
      return this.user.alias === this.expert.alias;
    },
    expertLink() {
      return `/${this.expert.alias}`;
    },
    experience() {
      const { expert } = this;
      const result = [];

      if (expert.age) {
        result.push(expert.age.title);
      }

      if (expert.experience) {
        result.push(`Стаж ${expert.experience.title}`);
      }

      return result;
    },
    lastJob() {
      const { expert } = this;
      const result = [];
      const job = expert.lastJob;

      if (job) {
        result.push({
          title: job.company.title,
          href: job.company.href,
        });

        if (job.position) {
          result.push({ title: job.position });
        }

        if (job.duration) {
          result.push({ title: job.duration.title });
        }
      }

      return result;
    },
    qualificationsAndSpecializations() {
      const groups = [
        {
          title: 'Квалификации',
          items: this.expert.qualifications,
        },
      ];

      if (this.expert.specializations.length) {
        groups.push({
          title: 'Специализации',
          items: this.expert.specializations,
        });
      }

      return groups;
    },
    skills() {
      if (!this.expert.skills.length) {
        return null;
      }

      return [
        {
          title: 'Навыки',
          items: this.expert.skills,
        },
      ];
    },
  },
};
</script>
